import GaLogger from './GaLogger';

class BingJSLogger extends GaLogger {
  getContentRenderedPayload(adtype, dabuResponse) {
    const {
      kramResponse = {},
    } = dabuResponse;
    const { pageParams, adContext } = this.adInstance;
    const { blocks } = this.win.amgAds.bingJsOptions;
    // TODO: add dimension for ad-type
    return {
      event: 'ad-content-rendered',
      abTestIds: adContext.abTestIds,
      ad_resultsDisplayedTop: blocks[0].count,
      ad_resultsDisplayedBottom: blocks[1].count,
      ad_resultsDisplayed: blocks[0].count + blocks[1].count,
      bingTypeTagPrimary: pageParams.rtb || dabuResponse.typeTag,
      bingTypeTagAbTests: adContext.abTestBingTypeTag,
      eventDate: new Date().toISOString(),
      eventType: dabuResponse.eventType,
      isGenericResponse: dabuResponse.isGenericResponse, // this field not useful for bing ads
      oCode: pageParams.o || dabuResponse.o,
      templateName: dabuResponse.templateName,
      generator: kramResponse.generator, // this field not useful for bing ads
      urlDomain: kramResponse.url_domain, // no kramResponse for bing ads
      urlSlug: kramResponse.url_slug, // no kramResponse for bing ads
      bingAdUnitId: dabuResponse.adUnitId,
      bingPropertyId: dabuResponse.propertyId,
    };
  }
}

export default BingJSLogger;
